import React from 'react';
import styles from './styles.module.css';
import * as Types from 'helpers/types';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import mastercardLogo from 'assets/mastercard-logo.svg';
import visaLogo from 'assets/visa-inc-logo.svg';
import americanExpressLogo from 'assets/american-express-logo.svg';
import jcbLogo from 'assets/jcb-logo.svg';
import discoverLogo from 'assets/discover-logo.svg';
import dciLogo from 'assets/dci-logo.svg';

const PaymentOptionCard = ({
  paymentOption,
  accountView = false,
  deleteView = false,
  deleteCard,
  error = false,
  manualJourney = false,
}) => {
  const dispatch = useDispatch();
  let history = useHistory();

  const navigatePaymentOption = () => {
    if (!accountView && !deleteView) {
      if (manualJourney) {
        dispatch({ type: Types.SET_MANUAL_PAYMENT, payload: paymentOption });
        history.push('/pharmacy/dashboard/manual-basket');
      } else {
        dispatch({ type: Types.PAYMENT_SET, payload: paymentOption });
        history.push('/pharmacy/dashboard/basket');
      }
    }
  };

  const displayCardLogo = (cardType) => {
    switch (cardType) {
      case 'MASTERCARD':
        return mastercardLogo;
      case 'VISA':
        return visaLogo;
      case 'AMERICAN EXPRESS':
        return americanExpressLogo;
      case 'JCB':
        return jcbLogo;
      case 'DISCOVER':
        return discoverLogo;
      case 'DINERS CLUB INTERNATIONAL':
        return dciLogo;
      default:
        return null;
    }
  };

  const cardStyles = (cardType) => {
    switch (cardType) {
      case 'MASTERCARD':
      case 'AMERICAN EXPRESS':
      case 'JCB':
      case 'DISCOVER':
      case 'DINERS CLUB INTERNATIONAL':
        return styles.extraCard;
      default:
        return '';
    }
  };

  return (
    <div
      className={`${styles.optionCard} ${!accountView && styles.clickable} ${cardStyles(
        paymentOption.type
      )} drop-shadow`}
      tabIndex="0"
      onKeyPress={(event) => (event.key === 'Enter' ? navigatePaymentOption() : null)}
      onClick={() => navigatePaymentOption()}>
      <div className={deleteView ? styles.deleteView : undefined}>
        <div className={styles.payment}>
          <img src={displayCardLogo(paymentOption.type)} alt="payment icon" className={styles.paymentLogoImg} />
          <p className={styles.paymentNumber}>•••• {paymentOption.number}</p>
          <p className={styles.paymentNumber}>
            {paymentOption.expiry && paymentOption.expiry.slice(0, 2)}/
            {paymentOption.expiry && paymentOption.expiry.slice(2, 4)}
          </p>
        </div>
        {deleteView && (
          <div
            className={styles.link_button}
            onClick={(e) => {
              e.stopPropagation();
              deleteCard(paymentOption.token);
            }}>
            Delete
          </div>
        )}
      </div>
      {error && deleteView ? <div className={styles.error_container}>{error}</div> : undefined}
    </div>
  );
};

export default PaymentOptionCard;
